application.register("part_ui_file", class extends Stimulus.Controller {
    connect() {
        this.element.querySelector("input").addEventListener("change", (e) => {
            this.element.querySelector("span").textContent = e.target.value.replace(/.*(\/|\\)/, '');
        });
    }
});